import { PolymerElement, html } from '@polymer/polymer';
import '@polymer/paper-button/paper-button.js';
import '@polymer/paper-toast/paper-toast.js';
import '@polymer/paper-icon-button/paper-icon-button.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/image-icons.js';
import '@polymer/iron-icons/editor-icons.js';
import '@polymer/iron-icons/maps-icons.js';
import '@polymer/iron-icons/social-icons.js';
import '@polymer/paper-tooltip/paper-tooltip.js';
import '@polymer/paper-dialog/paper-dialog.js';
import '@polymer/paper-dialog-scrollable/paper-dialog-scrollable.js';
import '../progress-bar/progress-bar.js';
import '../style-modules/paper-button-style.js';
import '../style-modules/paper-dialog-style.js';
import '../style-modules/paper-tooltip-style.js';
import '../bind-path/bind-path.js';
import '../user-chip/user-chip.js';

/*global Polymer*/
class ConfirmDialog extends PolymerElement {
  static get template() {
    return html`
      <style include="paper-button-style paper-dialog-style paper-tooltip-style">
        :host {
          font-family: Roboto;
        }
        #confirmDialog {
          max-width: 500px;
          @apply (--confirm-dialog);
        }
        #dialogHeading {
          width: 80%;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
        }
        #dialogBody {
          margin: 20px;
          font-size: 16px;
        }
        #message {
          display: block;
          text-align: center;
          font-size: 16px;
        }
        .buttons > paper-button {
          width: 50%;
          max-width: 150px;
          margin: 8px;
        }
        #dismiss {
          margin-right: auto;
        }
        #modalOverlay {
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-color: black;
          opacity: 0.4;
          transition: opacity 0.2s ease;
        }
      </style>
      <paper-toast id="confirmDialogToast"></paper-toast>
      <template is="dom-if" if="[[showOverlay(modal, confirmDialogOpened)]]" restamp>
        <div id="modalOverlay"></div>
      </template>
      <!-- TODO: this dialog needs to be converted to a katapult-dialog so that it can be a proper modal -->
      <paper-dialog
        id="confirmDialog"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
        opened="{{confirmDialogOpened}}"
        no-cancel-on-outside-click
        no-cancel-on-esc-key
      >
        <div title primary-color>
          <div id="dialogHeading">{{heading}}</div>
          <slot name="confirm-heading"></slot>
        </div>
        <paper-dialog-scrollable style="margin: 0;">
          <div id="dialogBody">
            <template is="dom-if" if="[[message]]">
              <span id="message">{{message}}</span>
            </template>
            <slot name="confirm-body"></slot>
          </div>
        </paper-dialog-scrollable>
        <div class="buttons">
          <paper-button
            id="dismiss"
            on-click="cancelCallback"
            dialog-dismiss
            style$="{{dismissiveStyle}}"
            outline
            hidden="{{hideDismissive}}"
            >{{dismissiveText}}</paper-button
          >
          <paper-button
            id="confirm"
            on-click="callback"
            dialog-confirm
            style$="{{affirmativeStyle}}"
            disabled="{{isConfirmDisabled}}"
            outline
            >{{affirmativeText}}</paper-button
          >
        </div>
      </paper-dialog>
    `;
  }

  static get is() {
    return 'confirm-dialog';
  }

  static get properties() {
    return {
      heading: {
        type: String,
        value: 'Confirm'
      },
      message: {
        type: String,
        value: ''
      },
      affirmativeText: {
        type: String,
        value: 'Confirm'
      },
      dismissiveText: {
        type: String,
        value: 'Cancel'
      },
      affirmativeStyle: {
        type: String,
        value: 'background-color: #007299; color: #fff;'
      },
      dismissiveStyle: {
        type: String,
        value: 'background-color: #fff; color: #000;'
      },
      callback: {
        type: Function,
        value: function () {
          return function () {};
        }
      },
      cancelCallback: {
        type: Function,
        value: function () {
          return function () {};
        }
      },
      confirmDialogOpened: {
        type: Boolean,
        value: false
      },
      isConfirmDisabled: {
        type: Boolean,
        value: false
      },
      hideDismissive: {
        type: Boolean,
        value: false
      },
      modal: {
        type: Boolean,
        value: false
      },
      // Use this to close the dialog using the confirm callback
      manualConfirmClose: {
        type: Boolean,
        value: false,
        observer: 'manualConfirmCloseChanged'
      }
    };
  }

  static get observers() {
    return [];
  }

  ready() {
    super.ready();
  }

  static get importMeta() {
    return import.meta;
  }

  // Methods go here

  openMessage(heading, message) {
    this.heading = heading || this.heading;
    this.message = message;
    this.$.confirmDialog.open();
  }

  openSlotted(heading) {
    this.heading = heading || this.heading;
    this.message = '';
    this.$.confirmDialog.open();
  }

  close() {
    this.$.confirmDialog.close();
  }

  manualConfirmCloseChanged() {
    if (this.manualConfirmClose) {
      this.$.confirm.removeAttribute('dialog-confirm');
    } else {
      this.$.confirm.setAttribute('dialog-confirm', '');
    }
  }

  toast(message) {
    this.$.confirmDialogToast.text = message;
    this.$.confirmDialogToast.open();
  }

  showOverlay() {
    let showOverlay = this.modal && this.confirmDialogOpened;
    if (showOverlay) {
      setTimeout(() => {
        this.shadowRoot.querySelector('#modalOverlay').style.zIndex = this.$.confirmDialog.style.zIndex;
      });
    }
    return showOverlay;
  }
}

customElements.define('confirm-dialog', ConfirmDialog);
